/** Only the local frontend on port 8000 disables periodic page data reads. */
export function getPageDataPollingInterval(): number | false {
  const isLocalTesting =
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost' &&
    window.location.port === '8000';
  return isLocalTesting ? false : 30_000;
}

export function startPageDataRefresh(refresh: () => void): number | undefined {
  const interval = getPageDataPollingInterval();
  if (interval === false) return undefined;
  return window.setInterval(refresh, interval);
}
